import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.css'],
    standalone: false
})
export class BannerComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal,
    public dialogRef: MatDialogRef<BannerComponent>) { }

  ngOnInit(): void {
  }

}
